import React from 'react';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
function HelpAnswerElement({ value, highlights, position }) {
    const actionProps = value.url
        ? {
            href: value.url,
            target: '_blank',
        }
        : null;
    const searchSection = 'Help';
    return (React.createElement(SectionItem, Object.assign({ expectedTitle: 1, expectedDescription: 2, cutDescription: 2 }, actionProps, { id: value.id, searchSection: searchSection, position: position }),
        React.createElement("div", { className: "WhSearch-SectionItem__title" },
            React.createElement(Highlight, { highlighted: highlights.title, content: value.title })),
        React.createElement("div", { className: "WhSearch-SectionItem__description" },
            React.createElement(Highlight, { highlighted: highlights.description, content: value.description }))));
}
export const HelpAnswerSection = createListSection(HelpAnswerElement, {
    title: 'sectionHelpAnswersTitle',
    maxCollapsed: 3,
});
//# sourceMappingURL=HelpAnswerSection.js.map